import $ from 'jquery';

export default () => {
    const sections = $('.js-interests-section');

    sections.each(function() {
        const slider = $(this).find('.js-interests-slider');
        const trigger = $(this).find('.js-interests-trigger');
        const dtrigger = $(this).find('.js-interests-d-trigger');

        dtrigger.on('click', function() {
            slider.slick('slickGoTo', $(this).index('dt'));
        });

        trigger.on('click', function() {
            slider.slick('slickGoTo', $(this).index());
        });

        slider.slick({
            slidesToShow: 1
        });
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/points-of-interest.js